/**
 * Homepage domain — utility types and constants.
 *
 * Domain entity type re-exports from generated types, plus the
 * `PAGE_KEYS` constant that mirrors `server/homepage/constants.py`
 * `PAGE_REGISTRY` keys.
 */

// ── Domain entity type re-exports ───────────────────────────────────

export type { PinListItem } from '../generated/types/PinListItem'
export type { RecentListItem } from '../generated/types/RecentListItem'
export type { TargetTypeEnum } from '../generated/types/TargetTypeEnum'

// ── Page key constants ───────────────────────────────────────────────

/**
 * Mirrors `server/homepage/constants.py` PAGE_REGISTRY keys.
 *
 * Used by consumers when calling `useRecordHomepageVisit` to identify
 * which page was visited.
 */
export const PAGE_KEYS = {
  documents: 'workspace.documents',
  products: 'workspace.products',
  brands: 'workspace.brands',
  activity: 'workspace.activity',
  reminders: 'workspace.reminders',
  settings: 'settings',
} as const

export type PageKey = (typeof PAGE_KEYS)[keyof typeof PAGE_KEYS]
